import qs, { StringifyOptions } from "query-string";
import { NavigateFunction } from "react-router-dom";

interface SubmitParamsType {
  handleClose?: () => void;
  navigate: NavigateFunction;
  pathname: string;
  newValues: Record<string, any>;
  parsedSearch: Record<string, any>;
  retry: () => void;
  stringifyOptions?: StringifyOptions;
}

export function submitQueryParams({
  handleClose,
  navigate,
  pathname,
  newValues,
  parsedSearch,
  retry,
  stringifyOptions = {},
}: SubmitParamsType): void {
  const unchanged = Object.entries(newValues).reduce(
    (prev, [key, value]) =>
      prev && ((value === undefined && !(key in parsedSearch)) || value === String(parsedSearch[key])),
    true
  );
  const paginationChanged =
    parsedSearch.pageNumber !== newValues.pageNumber || parsedSearch.pageSize !== newValues.pageSize;
  if (unchanged) {
    retry();
  } else if ((newValues.pageNumber || newValues.pageSize) && !paginationChanged) {
    navigate({
      pathname,
      search: qs.stringify(
        { ...parsedSearch, ...newValues, pageNumber: 1, pageSize: 10 },
        { arrayFormat: "comma", ...stringifyOptions }
      ),
    });
  } else {
    navigate({
      pathname,
      search: qs.stringify({ ...parsedSearch, ...newValues }, { arrayFormat: "bracket", ...stringifyOptions }),
    });
  }
  handleClose?.();
}

export const countQueryParams = (allParams: Record<string, any>, includeParams: Record<string, any>) => {
  const includeParamsSet = new Set(Object.keys(includeParams));
  const newArr = Object.keys(allParams).filter((param) => includeParamsSet.has(param));
  return newArr.length;
};
